var _rect, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHisPatient = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.75,
    width: 21.1111,
    height: 20.5,
    rx: 5.5,
    fill: "#918FEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9444 8.56944V6.97222C11.9444 6.19437 11.9444 5.80544 11.793 5.50835C11.6599 5.24701 11.4474 5.03453 11.1861 4.90138C10.889 4.75 10.5001 4.75 9.72222 4.75H7.22222C6.44437 4.75 6.05544 4.75 5.75835 4.90138C5.49701 5.03453 5.28453 5.24701 5.15138 5.50835C5 5.80544 5 6.19437 5 6.97222V15.0278C5 15.8056 5 16.1946 5.15138 16.4917C5.28453 16.753 5.49701 16.9655 5.75835 17.0986C6.05544 17.25 6.44437 17.25 7.22222 17.25H8.81944M5 11.6944H8.47222M5 14.4722H8.47222M9.86111 8.22223L7.08333 8.22222M8.47222 6.83333V9.61111M14.8611 12.0417C14.8611 12.6169 14.3947 13.0833 13.8194 13.0833C13.2442 13.0833 12.7778 12.6169 12.7778 12.0417C12.7778 11.4664 13.2442 11 13.8194 11C14.3947 11 14.8611 11.4664 14.8611 12.0417ZM16.1111 17.25V16.9028C16.1111 15.944 15.3338 15.1667 14.375 15.1667H13.3333C12.3745 15.1667 11.5972 15.944 11.5972 16.9028V17.25H16.1111Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHisPatient, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/his_patient.08032c3a.svg";
export { ForwardRef as ReactComponent };